import { LoadableAfterPaint } from '@confluence/loadable';

export const BlogTree = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-BlogTree" */ '../src/BlogTree')).BlogTree,
});
